import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>FYRMS (TIMM) rendszer értékelés és visszajelzés</h1>
		<p>Tisztelt Felhasználók, Kedves Kollégák!</p>
		<p>
			Egy 3 perces anonim kérdőív kitöltésére szeretnénk Önöket megkérni.
		</p>
		<p>
			A kérdőív célja meghallgatni a beutaló orvosok, adminisztrátorok és
			ápolók visszajelzését a FYRMS (TIMM) rendszer használatával
			kapcsolatban.{" "}
		</p>
		<p>
			Ez a kérdőív javítani kívánja a jelenlegi rendeletben és
			egészségügyi irányelvben meghatározott folyamatra épülő, szoftver
			segítségével történő, digitális referálási folyamatot, további
			segítséget nyújtani a szoftver használatához, az Önök felhasználói
			igényei szerint.
		</p>
		<p>
			Kérjük ossza meg velünk véleményét az alábbi linkre kattintva:
			<br />
			<a
				href="https://forms.gle/mocWXVAAdKycd1uR9"
				target="_blank"
				rel="noopener noreferrer"
			>
				https://forms.gle/mocWXVAAdKycd1uR9
			</a>
		</p>
		<p>
			Köszönettel, <br /> Budapesti Vese- és Vese-hasnyálmirigy
			transzplantációs Várólista Bizottság, <br /> Semmelweis Egyetem
			Klinikai Adatszolgáltató Intézet <br /> és a rendszer fejlesztői
		</p>
	</section>
);
